import React from 'react'
import { Helmet } from 'react-helmet'
import compose from 'recompose/compose'
import pure from 'recompose/pure'

const Title = ({ title }) => (
    <Helmet>
        <title>{title}</title>
    </Helmet>
)

export default compose(pure)(Title)
